import clsx from 'clsx';
import { useRecordTable } from '../../../../hooks/useRecordTable';
import PurchaseProductsHeader from './PurchaseProductsHeader';
import { CustomColumn } from '../../../Tables/record/RecordTable';
import TablePagination from '../../../Tables/base/TablePagination';
import PurchaseProductsBody from './PurchaseProductsBody';
import TableFooter from '../../../Tables/base/TableFooter';

interface PurchaseProductsTableProps<T extends object> {
  columns: CustomColumn<T>[];
  data: T[];
  pageSize?: number;
  noDataMessage?: string;
  showFooter?: boolean;
  showFilters?: boolean;
  maxWidth?: string;
}

const PurchaseProductsViewTable = <T extends object>({
  columns,
  data,
  noDataMessage = 'No hay registros disponibles.',
  showFooter = true,
  showFilters = true,
  pageSize = 10,
  maxWidth = 'max-w-6xl',
}: PurchaseProductsTableProps<T>) => {
  const table = useRecordTable<T>({ columns, data, pageSize });

  return (
    <div
      className={clsx(
        'mt-6 w-full rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark',
        maxWidth
      )}
    >
      <section className="data-table-common data-table-two border-b border-t border-stroke bg-white py-4 dark:border-strokedark dark:bg-boxdark">
        <div className="w-full overflow-x-auto p-2">
          <table
            {...table.getTableProps()}
            className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto"
          >
            <PurchaseProductsHeader table={table} showFilters={showFilters} />
            <PurchaseProductsBody table={table} noDataMessage={noDataMessage} />
            {showFooter && <TableFooter table={table} readOnly />}
          </table>
        </div>

        {/* Paginación */}
        <TablePagination table={table} />
      </section>
    </div>
  );
};

export default PurchaseProductsViewTable;
